import React, { useState } from "react";
import { Typography } from "@material-ui/core";
import { QueryStatus } from "react-query";
import { Paper } from "@material-ui/core";
import { Divider } from "@material-ui/core";
import CustomButton from "../../../components/buttons/CustomButton";
import { CollectorsSync, lastDBSync } from "../model/CollectorsSyncByTagFPType";
import { useClickPosition } from "../../../shared/globals/hooks/useClickPosition";
import { syncPanelDrawerWidth } from "./DeviceSyncPanel";
import PageContainer from "../../../components/containers/PageContainer";
import "./syncBox.css";
import { useLangLabels } from "../../../shared/lang/services/useLangLabels";

type svgSincPanelIconTypes = "update" | "info2" | "syncAction" | "syncBoxStatus" | "notification";

interface Props {
  colectorSyncsStatus: boolean | null | undefined;
  leftColectorsSync: undefined | CollectorsSync[] | [];
  syncBoxStatusColor: string;
  pendingSyncs: lastDBSync[];
  pendincColectorsSync: CollectorsSync[];
  actionStatus: QueryStatus;
  actionUpdateStatus: QueryStatus;
  handleSyncClick: () => void;
  handleUpdateSyncClick: () => void;
}

const SyncBoxIcon: React.FC<Props> = ({
  colectorSyncsStatus,
  leftColectorsSync,
  syncBoxStatusColor,
  pendingSyncs,
  pendincColectorsSync,
  handleSyncClick,
  handleUpdateSyncClick,
  actionStatus,
  actionUpdateStatus,
}) => {
  const { getClickPosition, resetClickPosition, position } = useClickPosition();
  const [hover, setHover] = useState(false);
  const [hoverElement, setHoverElement] = useState<svgSincPanelIconTypes | undefined>();
  const { lang } = useLangLabels();

  const handleHoverIn = (e: any, type: svgSincPanelIconTypes) => {
    getClickPosition(e, () => {
      setHover(true);
    });
    setHoverElement(type);
  };

  const handleHoverOut = () => {
    resetClickPosition(() => {
      setHover(false);
    });
    setHoverElement(undefined);
  };

  const ColectorsSyncList: React.FC<{ colectors: CollectorsSync[] | undefined }> = ({
    colectors,
  }) => {
    return (
      <>
        {!!colectors
          ? colectors?.map((colector: any, index: any) => (
              <Typography key={index}>
                {colector.collector}
                <br />
              </Typography>
            ))
          : null}
      </>
    );
  };

  const SvgHoverGroup: React.FC<{
    type: svgSincPanelIconTypes;
    handleClickAction?: () => void;
  }> = ({ children, type, handleClickAction }) => {
    const handleClick = () => {
      /* setStatus(QueryStatus.Loading) */
      if (actionStatus === "loading") {
        return;
      }
      handleClickAction && handleClickAction();
      handleHoverOut();
    };

    return (
      <>
        <g
          id="SvgHoverGroup"
          onClick={handleClick}
          onMouseEnter={e => handleHoverIn(e, type)}
          onMouseLeave={handleHoverOut}
        >
          {children}
        </g>
      </>
    );
  };

  const SvgButton: React.FC<{ type: svgSincPanelIconTypes }> = ({ type }) => (
    <>
      {type === "update" && (
        <g>
          <image
            className="cls-2"
            width="60"
            height="61"
            transform="translate(88.52 229)"
            href="data:image/png;base64,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"
          />
          <SvgHoverGroup type={type} handleClickAction={handleUpdateSyncClick}>
            <circle className="cls-3" cx="118.68" cy="259.7" r="14.8" />

            {actionUpdateStatus === "loading" ? (
              <path
                transform="translate(107,247.8)"
                className="cls-5"
                d="M19.43 12.98c.04-.32.07-.64.07-.98 0-.34-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.09-.16-.26-.25-.44-.25-.06 0-.12.01-.17.03l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.06-.02-.12-.03-.18-.03-.17 0-.34.09-.43.25l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98 0 .33.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.09.16.26.25.44.25.06 0 .12-.01.17-.03l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.06.02.12.03.18.03.17 0 .34-.09.43-.25l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zm-1.98-1.71c.04.31.05.52.05.73 0 .21-.02.43-.05.73l-.14 1.13.89.7 1.08.84-.7 1.21-1.27-.51-1.04-.42-.9.68c-.43.32-.84.56-1.25.73l-1.06.43-.16 1.13-.2 1.35h-1.4l-.19-1.35-.16-1.13-1.06-.43c-.43-.18-.83-.41-1.23-.71l-.91-.7-1.06.43-1.27.51-.7-1.21 1.08-.84.89-.7-.14-1.13c-.03-.31-.05-.54-.05-.74s.02-.43.05-.73l.14-1.13-.89-.7-1.08-.84.7-1.21 1.27.51 1.04.42.9-.68c.43-.32.84-.56 1.25-.73l1.06-.43.16-1.13.2-1.35h1.39l.19 1.35.16 1.13 1.06.43c.43.18.83.41 1.23.71l.91.7 1.06-.43 1.27-.51.7 1.21-1.07.85-.89.7.14 1.13zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
              />
            ) : (
              <path
                transform="translate(107,247.8)"
                className="cls-5"
                d="M11,8v5l4.25,2.52l0.77-1.28l-3.52-2.09V8H11z M21,10V3l-2.64,2.64C16.74,4.01,14.49,3,12,3c-4.97,0-9,4.03-9,9 s4.03,9,9,9s9-4.03,9-9h-2c0,3.86-3.14,7-7,7s-7-3.14-7-7s3.14-7,7-7c1.93,0,3.68,0.79,4.95,2.05L14,10H21z"
              />
            )}
            {actionUpdateStatus === "loading" && (
              <animateTransform
                attributeType="xml"
                attributeName="transform"
                type="rotate"
                from="0 118.68 259.7"
                to="360 118.68 259.7"
                dur="1s"
                additive="sum"
                repeatCount="indefinite"
              />
            )}
          </SvgHoverGroup>
        </g>
      )}

      {type === "info2" && (
        <g>
          <image
            className="cls-2"
            width="60"
            height="61"
            transform="translate(339.52 120)"
            href="data:image/png;base64,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"
          />
          <SvgHoverGroup type={type}>
            <circle className="cls-3" cx="369.52" cy="150.28" r="14.8" />
            <path
              className="cls-5"
              d="M368.64,145.83h1.77v1.78h-1.77Zm0,3.56h1.77v5.33h-1.77Zm.88-8a8.89,8.89,0,1,0,8.89,8.89A8.89,8.89,0,0,0,369.52,141.39Zm0,16a7.11,7.11,0,1,1,7.11-7.1A7.11,7.11,0,0,1,369.52,157.38Z"
            />
          </SvgHoverGroup>
        </g>
      )}

      {type === "syncAction" && (
        <g>
          <image
            className="cls-2"
            width="61"
            height="61"
            transform="translate(126.52)"
            href="data:image/png;base64,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"
          />
          <SvgHoverGroup
            handleClickAction={() => {
              actionStatus !== "loading" && handleSyncClick();
            }}
            type={type}
          >
            <circle className="cls-3" cx="157.03" cy="30.3" r="14.8" />
            <path
              className="cls-5"
              d="M157,21V17.57l-4.5,4.5,4.5,4.5V23.2A6.76,6.76,0,0,1,163.78,30,6.54,6.54,0,0,1,163,33.1l1.64,1.64A8.88,8.88,0,0,0,166,30,9,9,0,0,0,157,21Zm0,15.75A6.75,6.75,0,0,1,150.28,30a6.54,6.54,0,0,1,.79-3.15l-1.65-1.64A8.87,8.87,0,0,0,148,30a9,9,0,0,0,9,9v3.38l4.5-4.5-4.5-4.5Z"
            />
            {actionStatus === "loading" && (
              <animateTransform
                attributeType="xml"
                attributeName="transform"
                type="rotate"
                from="360 0157.03 30.3"
                to="0 157.03 30.3"
                dur="1s"
                additive="sum"
                repeatCount="indefinite"
              />
            )}
          </SvgHoverGroup>
        </g>
      )}
    </>
  );

  const SyncBox: React.FC<{ backgroundColor: string }> = ({ backgroundColor }) => {
    return (
      <SvgHoverGroup type="syncBoxStatus">
        {/* background */}
        <path
          fill={backgroundColor}
          d="M309,108.16A1.54,1.54,0,0,0,309,108a3.12,3.12,0,0,0-.18-.42c0-.07-.1-.12-.14-.19a4.15,4.15,0,0,0-.27-.32,1.56,1.56,0,0,0-.2-.16l-.22-.19-.12,0-.08,0L232.8,69.12a2.46,2.46,0,0,0-2.24,0l-74.94,37.47-.09,0-.11,0a1.81,1.81,0,0,0-.21.18L155,107a2.43,2.43,0,0,0-.24.3,1.77,1.77,0,0,0-.16.22,2.21,2.21,0,0,0-.16.35,2.77,2.77,0,0,0-.1.26,2.42,2.42,0,0,0-.07.47c0,.06,0,.12,0,.18v89.93a2.5,2.5,0,0,0,1.38,2.24l74.94,37.47s.08,0,.12,0a2.48,2.48,0,0,0,1,.23,2.52,2.52,0,0,0,1-.23s.08,0,.12,0L307.74,201a2.5,2.5,0,0,0,1.38-2.24V108.82A2.39,2.39,0,0,0,309,108.16Z"
        />

        {/* box */}
        <path
          className="cls-5"
          d="M309,108.16A1.54,1.54,0,0,0,309,108a3.12,3.12,0,0,0-.18-.42c0-.07-.1-.12-.14-.19a4.15,4.15,0,0,0-.27-.32,1.56,1.56,0,0,0-.2-.16l-.22-.19-.12,0-.08,0L232.8,69.12a2.46,2.46,0,0,0-2.24,0l-74.94,37.47-.09,0-.11,0a1.81,1.81,0,0,0-.21.18L155,107a2.43,2.43,0,0,0-.24.3,1.77,1.77,0,0,0-.16.22,2.21,2.21,0,0,0-.16.35,2.77,2.77,0,0,0-.1.26,2.42,2.42,0,0,0-.07.47c0,.06,0,.12,0,.18v89.93a2.5,2.5,0,0,0,1.38,2.24l74.94,37.47s.08,0,.12,0a2.48,2.48,0,0,0,1,.23,2.52,2.52,0,0,0,1-.23s.08,0,.12,0L307.74,201a2.5,2.5,0,0,0,1.38-2.24V108.82A2.39,2.39,0,0,0,309,108.16Zm-77.35-34L301,108.82,231.68,143.5l-69.36-34.68Zm-72.44,38.72,69.94,35v84.34l-69.94-35Zm74.94,119.32V147.84l69.94-35v84.35Z"
        />

        {/* Sync box Text*/}
        <g>
          <path
            className="cls-5"
            d="M249.58,161.65q0-.68-.48-.81a4.38,4.38,0,0,0-1.68.08,13.34,13.34,0,0,1-2,.22c-1.66,0-2.49-.67-2.49-2.09a4.56,4.56,0,0,1,.62-2.19,8.62,8.62,0,0,1,1.76-2.16,11.35,11.35,0,0,1,2.54-1.75,6.53,6.53,0,0,1,2.48-.77,2.15,2.15,0,0,1,1.7.54,2.39,2.39,0,0,1,.6,1.76l-3.07,1.57c0-.52-.16-.84-.48-1a1.71,1.71,0,0,0-1.3.23,3.91,3.91,0,0,0-1.3,1,1.93,1.93,0,0,0-.48,1.17.61.61,0,0,0,.53.63,5.35,5.35,0,0,0,1.85-.12,9.27,9.27,0,0,1,2.18-.2,2,2,0,0,1,2.07,2.24,5.27,5.27,0,0,1-1.26,3.28,10.33,10.33,0,0,1-3.47,2.73,7.46,7.46,0,0,1-2.82.87,2.29,2.29,0,0,1-1.89-.56,2.59,2.59,0,0,1-.64-1.91l3.09-1.57c0,.68.18,1.1.53,1.24a2.4,2.4,0,0,0,1.73-.39,3.68,3.68,0,0,0,1.21-.95A1.84,1.84,0,0,0,249.58,161.65Z"
          />
          <path
            className="cls-5"
            d="M258.92,153.05l2.36-6.75,3.33-1.7-4.12,10.3v4.59l-3.13,1.59v-4.59l-4.11-6.1,3.31-1.69Z"
          />
          <path
            className="cls-5"
            d="M276.22,151.48,273.15,153l-4.53-5.65v8l-3.08,1.57V144.13l3.08-1.57,4.52,5.65v-8l3.08-1.56Z"
          />
          <path
            className="cls-5"
            d="M288.51,140.88a6.94,6.94,0,0,1-.72,2.73,9.24,9.24,0,0,1-1.84,2.52,11.06,11.06,0,0,1-2.72,2c-1.68.86-3,1-4,.38s-1.45-1.9-1.45-3.9v-.63a10.35,10.35,0,0,1,.65-3.62,10,10,0,0,1,1.89-3.14,9.51,9.51,0,0,1,2.84-2.22c1.55-.79,2.8-1,3.74-.68a2.66,2.66,0,0,1,1.61,2.56l-3.07,1.56c0-.76-.22-1.22-.59-1.37a2.16,2.16,0,0,0-1.69.35,3.55,3.55,0,0,0-1.68,1.72,7.36,7.36,0,0,0-.57,3V143a4.5,4.5,0,0,0,.52,2.66c.34.41.93.4,1.77,0a4.46,4.46,0,0,0,1.62-1.33,3.33,3.33,0,0,0,.6-1.9Z"
          />
          <path
            className="cls-5"
            d="M243,190V177.21l4.6-2.34a6.41,6.41,0,0,1,3.75-1c.86.16,1.29.82,1.29,2a4.31,4.31,0,0,1-.46,1.93,5.62,5.62,0,0,1-1.34,1.72,1.64,1.64,0,0,1,1.53.2,1.82,1.82,0,0,1,.54,1.48,5.5,5.5,0,0,1-1.19,3.43,10.16,10.16,0,0,1-3.53,2.76Zm3.09-9,1.6-.82a4,4,0,0,0,1.44-1.11,2.06,2.06,0,0,0,.43-1.28c0-.54-.15-.85-.46-.93a2.49,2.49,0,0,0-1.5.41l-1.51.77Zm0,2v3.06l2-1a3.53,3.53,0,0,0,1.28-1,2.17,2.17,0,0,0,.45-1.31c0-1.06-.53-1.33-1.59-.79Z"
          />
          <path
            className="cls-5"
            d="M265.41,172.44a10.15,10.15,0,0,1-.69,3.66,10.34,10.34,0,0,1-2,3.22,9.86,9.86,0,0,1-2.91,2.26,5.47,5.47,0,0,1-2.9.73,2.53,2.53,0,0,1-2-1.14,5.22,5.22,0,0,1-.75-2.83v-.72a10.12,10.12,0,0,1,.69-3.67,10.41,10.41,0,0,1,2-3.22,10,10,0,0,1,2.93-2.28,5.37,5.37,0,0,1,2.9-.7,2.56,2.56,0,0,1,2,1.19,5.22,5.22,0,0,1,.71,2.91Zm-3.13,1.06a3.76,3.76,0,0,0-.64-2.57c-.42-.44-1-.46-1.82-.06-1.55.79-2.36,2.36-2.45,4.73v.94a4,4,0,0,0,.62,2.57c.42.46,1,.48,1.86.07a4,4,0,0,0,1.8-1.91,7.48,7.48,0,0,0,.64-3.18Z"
          />
          <path
            className="cls-5"
            d="M271.58,166.89l2.09-5.32,3.52-1.79-3.57,8.16,3.67,4.58-3.56,1.81-2.15-3.24-2.15,5.43-3.55,1.81,3.66-8.31L266,165.49l3.51-1.79Z"
          />
        </g>
      </SvgHoverGroup>
    );
  };

  const SyncBoxNotification: React.FC<{ quantity: number }> = ({ quantity }) => {
    return quantity === 0 ? null : (
      <SvgHoverGroup type="notification">
        <circle fill="red" cx="305" cy="110" r="12" />
        <text fill="#FFFFFF" fontSize="18" fontWeight="700" x="300.5" y="116.25">
          {quantity}
        </text>
      </SvgHoverGroup>
    );
  };

  return (
    <>
      {hover && (
        <Paper
          onMouseLeave={handleHoverOut}
          style={{
            maxWidth: "350px",
            position: "absolute",
            top: `calc( ${position.positionY}px - 50px )`,
            left: `calc( ${position.positionX}px - ${100 - syncPanelDrawerWidth}vw - 80px )`,
            zIndex: 10000,
          }}
          elevation={2}
        >
          <PageContainer padding="16px">
            {hoverElement === "update" && (
              <>
                <Typography variant="h6">{lang.collectorSync.updateSyncBoxData}</Typography>
                <Divider />
                <br />
                <Typography variant="body1">
                  {lang.collectorSync.updateSyncBoxDataDescription}
                </Typography>
                <br />
                <Typography variant="h6">
                  {lang.collectorSync.howToSynchronizeTheSyncBox}
                </Typography>

                <Typography variant="body1">
                  {lang.collectorSync.howToSynchronizeTheSyncBoxDescription}
                </Typography>
              </>
            )}

            {hoverElement === "info2" && (
              <>
                <Typography variant="h6">{lang.collectorSync.synchronizeCollectors}</Typography>
                <Divider />
                <br />
                <Typography variant="body1">
                  {lang.collectorSync.synchronizeCollectorsDescription}
                </Typography>
              </>
            )}

            {hoverElement === "syncAction" && (
              <>
                <Typography variant="h6">{lang.collectorSync.synchronizeSyncBox}</Typography>
                <Divider variant="inset" />
                <Divider />
                <br />
                <Typography variant="body1">
                  {lang.collectorSync.synchronizeSyncBoxDescription}
                </Typography>
              </>
            )}

            {hoverElement === "syncBoxStatus" && (
              <>
                <Typography variant="h6">
                  <CustomButton
                    variant="iconButton"
                    icon="state"
                    styleProps={{ color: syncBoxStatusColor }}
                  />
                  {lang.collectorSync.syncBoxState}
                </Typography>
                <Divider variant="inset" />
                <Divider />
                <br />
                {colectorSyncsStatus === null && (
                  <>
                    <Typography variant="body1">
                      {lang.collectorSync.syncBoxStateDescription}
                    </Typography>
                    <br />
                    <Typography variant="body1">
                      <strong>
                        {lang.collectorSync.unsynchronizedCollectors}
                        <br />
                      </strong>
                      <ColectorsSyncList colectors={leftColectorsSync} />
                    </Typography>
                  </>
                )}

                {colectorSyncsStatus === false && (
                  <>
                    <Typography variant="body1">
                      {lang.collectorSync.someCollectorsHaveBeenSynchronized}
                    </Typography>
                    <br />
                    <Typography variant="body1">
                      <strong>
                        {lang.collectorSync.missingCollectors}
                        <br />
                      </strong>
                      <ColectorsSyncList colectors={leftColectorsSync} />
                    </Typography>
                  </>
                )}

                {colectorSyncsStatus === true && (
                  <>
                    <Typography variant="body1">
                      {lang.collectorSync.collectorsWereSynchronizedAtLeastOnce}
                    </Typography>
                  </>
                )}
              </>
            )}

            {hoverElement === "notification" && (
              <>
                <Typography variant="h6">{lang.collectorSync.pendingSyncs}</Typography>
                <Divider variant="inset" />
                <Divider />
                <br />
                <Typography variant="body1">
                  {lang.collectorSync.pendingSyncsDescription}
                  <br />
                  <ColectorsSyncList colectors={pendincColectorsSync} />
                </Typography>
                <br />
                <Typography variant="body2">{lang.collectorSync.toKeepSoftUpdated}</Typography>
              </>
            )}
          </PageContainer>
        </Paper>
      )}

      <svg xmlns="http://www.w3.org/2000/svg" height="40vh" viewBox="-50 0 550 300">
        <g className="cls-1">
          <g id="Capa_1-2" data-name="Capa 1">
            {/* Line sync */}
            <g>
              {/* Line sync */}
              <polyline className="cls-4" points="54.22 122.05 157.03 69.97 235.97 109.71" />
              {/* Arrow */}
              <polygon
                className="cls-5"
                points="58.4 124.08 55.32 121.49 55.05 117.47 48.9 124.75 58.4 124.08"
              />
              {/* Vertical Line Sync  */}
              <line className="cls-4" x1="157.03" y1="69.97" x2="157.03" y2="45.1" />
            </g>

            <SvgButton type="update" />

            <SyncBox backgroundColor={syncBoxStatusColor} />

            {/* SyncBox lines Info 1 */}
            <g>
              {/* Line */}
              <polyline className="cls-4" points="191.79 179.45 118.68 216.49 50.64 176.81" />
              {/* Arrow */}
              <polygon
                className="cls-5"
                points="187.62 177.42 190.69 180.01 190.96 184.02 197.12 176.75 187.62 177.42"
              />
              {/* Vertical line */}
              <line className="cls-4" x1="118.68" y1="216.49" x2="118.68" y2="244.9" />
            </g>

            <SvgButton type="syncAction" />

            {/* Phone line & Arrows */}
            <g>
              <line className="cls-4" x1="326.06" y1="150.45" x2="406.71" y2="150.45" />
              <polygon
                className="cls-5"
                points="328.87 154.16 327.3 150.45 328.87 146.75 320.09 150.45 328.87 154.16"
              />
              <polygon
                className="cls-5"
                points="403.9 154.16 405.47 150.45 403.9 146.75 412.68 150.45 403.9 154.16"
              />
            </g>

            <SvgButton type="info2" />

            {/* Desktop & Phone icons */}
            <g>
              {/* Desktop */}
              <path
                className="cls-5"
                d="M39,134.3H3.9A3.91,3.91,0,0,0,0,138.2v23.38a3.91,3.91,0,0,0,3.9,3.9H17.54v3.9h-3.9v3.89H29.23v-3.89h-3.9v-3.9H39a3.91,3.91,0,0,0,3.9-3.9V138.2A3.91,3.91,0,0,0,39,134.3Zm0,27.28H3.9V138.2H39Z"
              />
              {/* Phone */}
              <path
                className="cls-5"
                d="M449.45,128.49l-17.95,0a3.8,3.8,0,0,0-3.59,4v35.67a3.8,3.8,0,0,0,3.59,4h17.95a3.8,3.8,0,0,0,3.58-4V132.44A3.78,3.78,0,0,0,449.45,128.49Zm-4.93,38.84h-8.38a.85.85,0,0,1-.86-.86v-.35a.85.85,0,0,1,.86-.86h8.38a.86.86,0,0,1,.86.86v.35A.86.86,0,0,1,444.52,167.33Zm4.31,2.42H432.11a2,2,0,0,1-1.82-2.09V133.24a2,2,0,0,1,1.82-2.08h16.72a2,2,0,0,1,1.83,2.08v34.42A2,2,0,0,1,448.83,169.75Z"
              />
            </g>

            <SyncBoxNotification quantity={pendingSyncs.length} />
          </g>
        </g>
      </svg>
    </>
  );
};

export default SyncBoxIcon;
